import ScrollHandler from "../../src/parts/ScrollHandler";
import RoutemParticleHandler from "../../src/parts/RoutemParticleHandler";
const scrollHandler = new ScrollHandler();
const routemParticleHandler = new RoutemParticleHandler();

window.addEventListener('DOMContentLoaded', () => {
    const headerEl = document.querySelector('#header');   
    const dropdownEl = document.querySelector("#signInDropdown");
    
    dropdownEl.style.removeProperty("opacity");
    dropdownEl.style.removeProperty("pointer-events");

    args.triggerIDs.forEach( triggerID => {
        headerEl.querySelector("#" + triggerID).addEventListener("click", e => {
            headerEl.classList.add("sign-in-open");
            e.target.closest("#" + triggerID).classList.add("active");
            dropdownEl.classList.add("open");
            scrollHandler.disableScroll();
            routemParticleHandler.logSignInNavTappedEvent();
        });

        dropdownEl.querySelector("#closeSignInDropdown").addEventListener("click", () => {
            headerEl.querySelector("#" + triggerID).classList.remove("active");
        });
    });

    dropdownEl.querySelector("#closeSignInDropdown").addEventListener("click", () => {
        headerEl.classList.remove("sign-in-open");
        dropdownEl.classList.remove("open");
        scrollHandler.enableScroll();
    });

    dropdownEl.querySelector("#routeShopperClaim").addEventListener("click", () => {
        routemParticleHandler.logShopperClaimButtonTappedEvent();
    });

    dropdownEl.querySelector("#routeShopperSignIn").addEventListener("click", () => {
        routemParticleHandler.logShopperSignInButtonTappedEvent();
    });

    dropdownEl.querySelector("#routeMerchantSignIn").addEventListener("click", () => {
        routemParticleHandler.logMerchantSignInButtonTappedEvent();
    });
});